/**
 * The App Store's front-door routes (ADR 0028). They paint full-bleed dark bands, so
 * AppLayout's content padding and max width are turned off for these paths only.
 */
const FRONT_DOOR_PATHS: ReadonlySet<string> = new Set(['/', '/about', '/about/stack']);

/** True for a front-door route, with or without trailing slashes ("/about/"). */
export function isFrontDoorPath(pathname: string): boolean {
  return FRONT_DOOR_PATHS.has(pathname.replace(/\/+$/, '') || '/');
}
